var $5e16d5c081004e02$exports = {};
$5e16d5c081004e02$exports = import.meta.resolve("C2hFJ");


var $3886a3d901723bcc$exports = {};
$3886a3d901723bcc$exports = import.meta.resolve("itMHT");


var $53b0e452e408af29$exports = {};
$53b0e452e408af29$exports = import.meta.resolve("jVl13");


var $3d5e8f1875d45e89$exports = {};
$3d5e8f1875d45e89$exports = import.meta.resolve("2xE1R");


var $aef6ef019924a2a4$exports = {};
$aef6ef019924a2a4$exports = import.meta.resolve("SJZbU");


var $1df4f0172128306b$exports = {};
$1df4f0172128306b$exports = import.meta.resolve("fr39B");


var $6fa6b137ec90acab$exports = {};
$6fa6b137ec90acab$exports = import.meta.resolve("lQ2Jl");


var $1124ff291aa79b52$exports = {};
$1124ff291aa79b52$exports = import.meta.resolve("fzJoC");


var $ed694db837945de5$exports = {};
$ed694db837945de5$exports = import.meta.resolve("4guzs");


var $01f334696a40ceae$exports = {};
$01f334696a40ceae$exports = import.meta.resolve("8sP9i");


var $b1f5a78692dae1e0$exports = {};
$b1f5a78692dae1e0$exports = import.meta.resolve("kbdwv");


var $e146143807133f5a$exports = {};
$e146143807133f5a$exports = import.meta.resolve("l0szO");


var $961598e0908d66a2$exports = {};
$961598e0908d66a2$exports = import.meta.resolve("lwOlC");


var $06b026b6d6cefe38$exports = {};
$06b026b6d6cefe38$exports = import.meta.resolve("3Bxhu");


var $8cd88f9534b22b7e$exports = {};
$8cd88f9534b22b7e$exports = import.meta.resolve("jDGuO");


var $04ffd3a59621bb81$exports = {};
$04ffd3a59621bb81$exports = import.meta.resolve("6TtHk");


var $f45e6e10cac42f3a$exports = {};
$f45e6e10cac42f3a$exports = import.meta.resolve("iap0T");


document.addEventListener('DOMContentLoaded', ()=>{
    const buttons = document.querySelectorAll('.phone-button');
    const displayArea = document.getElementById('main-display');
    const storyDisplay = document.getElementById('story-display');
    const storyText = document.getElementById('story-text');
    const birdImage = document.getElementById('bird-image');
    const closeBtn = document.getElementById('close-story');
    const audioPlayer = document.getElementById('audio-player');
    const progress = document.getElementById('progress');
    const timeDisplay = document.getElementById('time-display');
    const pigeonBox = document.querySelector('.pigeon-box');
    const coinSlot = document.querySelector('.coin-slot-unit');
    const coinReturn = document.querySelector('.coin-return');
    // Coin Animation Logic
    coinSlot.addEventListener('click', ()=>{
        if (document.querySelector('.falling-coin')) return; // Prevent spamming
        const coin = document.createElement('div');
        coin.className = 'falling-coin';
        coin.textContent = 'O';
        displayArea.appendChild(coin);
        // Remove coin after animation
        setTimeout(()=>{
            coin.remove();
        }, 1000);
        // Knock down pigeon when coin hits (approx 0.5s into animation)
        setTimeout(()=>{
            pigeonBox.classList.add('knocked');
            setTimeout(()=>{
                pigeonBox.classList.remove('knocked');
            }, 800);
        }, 400);
    });
    // Coin Return Animation (Tray)
    coinReturn.addEventListener('click', ()=>{
        if (document.querySelector('.return-coin')) return;
        const coin = document.createElement('div');
        coin.className = 'return-coin';
        coin.textContent = 'O';
        displayArea.appendChild(coin);
        setTimeout(()=>coin.remove(), 800);
        // Pigeon squish effort
        pigeonBox.classList.add('return-squish');
        setTimeout(()=>{
            pigeonBox.classList.remove('return-squish');
        }, 600);
    });
    const stories = {
        '1': {
            name: 'Tracey',
            text: "They say I\u2019m a small package with a big personality, draped in beautiful blue feathers. I'm an acrobatic performer, and it's no secret that I just loooooove nuts. I am utterly impossible to ignore, on a slow day my favorite move is the \u2018upside down on a pole\u2019 It always works. Are you paying attention yet?",
            img: new URL($5e16d5c081004e02$exports).toString(),
            audio: new URL($3886a3d901723bcc$exports).toString()
        },
        '2': {
            name: 'Gilly',
            text: 'I take anything... and I mean anything. Chips, ice cream, entire sandwiches right out of your hands. I\'m completely unstoppable, and impossible to resist. Fair warning, though: don\'t make eye contact. You won\'t stand a chance.',
            img: new URL($53b0e452e408af29$exports).toString(),
            audio: new URL($3d5e8f1875d45e89$exports).toString()
        },
        '3': {
            name: 'Monty',
            text: "Well hello there darling. I really love shiny things... my eyes are always wiiiiiiiide open and I positively insist on the finest jewellery. I\u2019ll take a Rolex for breakfast and a Tiffany for tea. Mummy says I\u2019m an astonishingly professional collector of  jolly beautiful treasures.  Now you may laugh, but once I lay my hands on something spiffing I absolutely refuse to relinquish it. Tally ho old boy and chop chop.",
            img: new URL($aef6ef019924a2a4$exports).toString(),
            audio: new URL($1df4f0172128306b$exports).toString()
        },
        '4': {
            name: 'Vera',
            text: "I'll wait \u2026. and I\u2019ll wait \u2026.. Until \u2026.... Well you know. I have excellent timing, you see. (sqwaaak) I like things rich, complex, and \u2026\u2026. matured. There is no need to rush. I am very patient, and the sweetest things are always worth the wait.",
            img: new URL($6fa6b137ec90acab$exports).toString(),
            audio: new URL($1124ff291aa79b52$exports).toString()
        },
        '5': {
            name: 'Donny',
            text: '"Sorry... you\'ve just missed him."\n',
            img: "a",
            audio: new URL($ed694db837945de5$exports).toString()
        },
        '6': {
            name: 'Monique',
            text: 'Bonjour mon ami ca va I am Monique, Mo-nique, look at me i am doing  the thing with my plume, voila ... my feathers are green and orange, magnificient manteinant, I require an Homme who likes the va va voom, flamboyant exits and sensational spinning round, oh la la, I will give you a lemon twist, every 5 minute, while shouting "Regardez-moi, dans les yeux, tout alors!", I can not afford to work for free, c\'est la vie, qui, qua, au revoir.",   ',
            img: "a",
            audio: new URL($01f334696a40ceae$exports).toString()
        },
        '7': {
            name: 'Oscar',
            text: 'Who? I am Oscar. A mature night owl, a quiet, attentive listener, and a wise beyond my feathers. I thrive in the deep hours of the night. And yes... I can rotate my head nearly all the way round. I can watch you, and adore you, from absolutely any angle.',
            img: "a",
            audio: new URL($b1f5a78692dae1e0$exports).toString()
        },
        '8': {
            name: 'Peter',
            text: "Ice, Ice baby... keeping it cool is just what I do. I\u2019I dress to impress \u2014 nothing but tuxedos and jimmy Choos for me. I am a deeply loyal partner, and I walk with a swagger so natural you'd swear I was John Wayne. Well, do you feel lucky punk? If so, come a little closer\u2026 my 44 is going to  to keep you warm baby.",
            img: "a",
            audio: new URL($e146143807133f5a$exports).toString()
        },
        '9': {
            name: 'Ray',
            text: "I\u2019m Dark. Mysterious. I already know your secrets. I am highly intelligent, delightfully gothic, and I laugh at funerals just foor the thrill. You can try to hide from me, but I can see right through you. Speak... I'm listening.",
            img: "a",
            audio: new URL($961598e0908d66a2$exports).toString()
        },
        '0': {
            name: 'Credits',
            text: 'This exhibition was brought to you by:Matteo Cancellieri: you can find his work at matteocancellieri.com (good luck spelling that), Tony Gee: find his otherworldly sounds and creations @RedFishSounds on Instagram and David Pride: you can find his magic at @davidpride3160 on Youtube. Voice Actors: Angelica Andersson, Sus Booth and Rapha Weedon.',
            img: "a",
            audio: new URL($06b026b6d6cefe38$exports).toString()
        },
        '*': {
            name: 'ArtBox',
            text: 'ARTBOX transforms a classic Leighton Buzzard High Street red telephone box into an accessible, vibrant space for showcasing the talent of our town. Founded by three local creatives, Sally, Lobke and Tony this unique project aims to bring joyful, ever-changing art directly to the community. Search "Artbox LB" on Facebook to learn more and follow along.',
            img: "a",
            audio: new URL($8cd88f9534b22b7e$exports).toString()
        },
        '#': {
            name: 'Singalong',
            text: 'Birdie Birde - RedFish Sounds',
            img: "a",
            audio: new URL($04ffd3a59621bb81$exports).toString()
        },
        'intro': {
            name: 'Singalong',
            text: "I\u2019m Dark. Mysterious. I already know your secrets. I am highly intelligent, delightfully gothic, and I laugh at funerals just for the thrill. You can try to hide from me, but I can see right through you. Speak... I'm listening.",
            img: "a",
            audio: new URL($f45e6e10cac42f3a$exports).toString()
        }
    };
    buttons.forEach((btn)=>{
        btn.addEventListener('click', ()=>{
            const key = btn.getAttribute('data-key');
            if (stories[key]) showStory(key);
        });
    });
    function showStory(key) {
        const story = stories[key];
        // Audio
        audioPlayer.src = story.audio;
        audioPlayer.play().catch((e)=>console.warn("Play blocked", e));
        // Display
        storyText.textContent = story.text;
        birdImage.style.backgroundImage = `url(${story.img})`;
        pigeonBox.classList.add('hidden');
        storyDisplay.classList.remove('hidden');
        displayArea.classList.add('spinning');
    }
    audioPlayer.addEventListener('timeupdate', ()=>{
        const pct = audioPlayer.currentTime / audioPlayer.duration * 100;
        progress.style.width = `${pct}%`;
        const mins = Math.floor(audioPlayer.currentTime / 60);
        const secs = Math.floor(audioPlayer.currentTime % 60).toString().padStart(2, '0');
        timeDisplay.textContent = `${mins}:${secs}`;
    });
    closeBtn.addEventListener('click', ()=>{
        audioPlayer.pause();
        audioPlayer.currentTime = 0;
        storyDisplay.classList.add('hidden');
        pigeonBox.classList.remove('hidden');
        displayArea.classList.remove('spinning');
    });
    audioPlayer.addEventListener('ended', ()=>{
        displayArea.classList.remove('spinning');
    });
});


//# sourceMappingURL=avian-influencer.b2541f64.js.map
